<template>
    <Wrapper>
        <div class="row">
            <div class="col-12 py-2">
                <div class="card card-body mb-4 shadow-sm">
                    <h4 class="font-weight-light mb-3">DataTables</h4>
                    <DataTable></DataTable>
                </div>
            </div>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper, DataTable } from '../components';

export default {
    components: {
        Wrapper,
        DataTable
    }
};
</script>
